import jquery from "jquery";
// export for others scripts to use
window.$ = window.jQuery = jquery;
global.$ =  global.jQuery = jquery;
import './library/bluebird'
import './library/bounceback.min'
import 'lazysizes'
import './library/ls.rias.js'
import './library/ls.bgset.js'
import './library/custom'